import { FIELD_PRIMITIVE__bool } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__bool';
import { G_HOOK__output__field_hovered_set } from '../_base/_hooks/G_HOOK__output__field_hovered_set';
import { G_UI_FIELD__header } from '../_base/G_UI_FIELD__header';
import { G_UI_FIELD_PRIMITIVE__bool_checkbox } from './G_UI_FIELD_PRIMITIVE__bool_checkbox';
import { G_UI_FIELD_PRIMITIVE__bool_list } from './G_UI_FIELD_PRIMITIVE__bool_list';

interface PROPS {
  field: FIELD_PRIMITIVE__bool;
}

export function G_UI_FIELD_PRIMITIVE__bool_master({ field }: PROPS) {
  /*
   * STATE
   */

  const { onMouseOver, onMouseLeave } = G_HOOK__output__field_hovered_set({ field });

  /*
   * HTML
   */

  return (
    <div className="flex flex-col w-full min-w-0" {...{ onMouseOver, onMouseLeave }}>
      {/* HEADER */}
      <G_UI_FIELD__header {...{ field }} />

      {/* CONTENT */}
      <div className="w-full bg-component min-w-0 py-2 px-1">
        {field.meta.grid2d__is_dimension ? <G_UI_FIELD_PRIMITIVE__bool_list {...{ field }} /> : <G_UI_FIELD_PRIMITIVE__bool_checkbox {...{ field }} />}
      </div>
    </div>
  );
}
